module.exports = __webpack_public_path__ + "img/lawtele2.332379e6.png";